import { Hero } from "@/components/home/Hero";
import { ServiceBento } from "@/components/home/ServiceBento";
import { ServiceArea } from "@/components/home/ServiceArea";
import { Process, WhyUs } from "@/components/home/Trust";
import { Marquee } from "@/components/site/Marquee";
import { QuoteCTA } from "@/components/site/QuoteCTA";
import { useSeo } from "@/components/site/Seo";

export default function Home() {
  useSeo({
    title: "Assemble Pro | Assembly & Installation in Woodstock, Ingersoll & Oxford County",
    description: "You buy it. We assemble it. We install it. Furniture assembly, BBQs, gazebos, sheds, fitness equipment, TV mounting, blinds, shelving and gates in Woodstock, Ingersoll and Oxford County, Ontario.",
    path: "/",
  });
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <ServiceBento />
      <Process />
      <ServiceArea />
      <WhyUs />
      <QuoteCTA />
    </div>
  );
}
